<ng-container>
  <div class="d-flex flex-column gap-2 pb-3" style="position: relative;">
    <div style="color: #4A5568;">Nhóm sản phẩm</div>
    <div
      class="d-flex gap-2 list-tags"
      [class.show-all]="isShowAllTags"
    >
      <ng-container
        *ngTemplateOutlet="
          recursiveMenu;
          context: { $implicit: categories }
        "
      ></ng-container>
    </div>
    <div
      class="view-more-btn d-md-none d-flex align-items-center justify-content-center"
      [ngClass]="{ expanding: isShowAllTags }"
    >
      <span (click)="toggleShowTags()" style="cursor: pointer;">{{ isShowAllTags ? 'Thu gọn' : 'Mở rộng' }}</span>
      <i
          class="ri-arrow-down-s-line arrow"
          [ngClass]="{ rotate: isShowAllTags }"
          style="font-size: 24px; font-weight: 400; line-height: 24px;"
        ></i>
    </div>
  </div>
</ng-container>

<ng-template #recursiveMenu let-items>
  <ng-container *ngFor="let category of items; let i = index">
    <div class="category-wrapper" [class.menu-open]="category.selected || category.isShow">
      <div
        class="d-flex category-tag gap-2"
        [style.--cate-color]="category.color"
        [ngClass]="{
          active: category.active || category.childrenSelected,
          selected: category.selected,
          hovered: category.isHover
        }"
        (mouseenter)="category.isHover = checkHoverFollowScreenSize(true)"
        (mouseleave)="category.isHover = false"
        (click)="selecteCate(category); $event.stopPropagation()"
      >
        <img
          *ngIf="category.icon"
          [src]="
            (category.isHover && !category.active)
              ? category.hoverIcon
              : (category.active || category.childrenSelected)
                ? category.activeIcon
                : category.icon
          "
          style="width: 20px; height: 20px;"
          [alt]="category.name"
         loading="lazy" />

        <div>{{ category.name }}</div>

        <i
          *ngIf="category.children?.length"
          class="ri-arrow-down-s-line arrow"
          [ngClass]="{ rotate: category.selected }"
          style="font-size: 24px; font-weight: 400; line-height: 20px;"
          (click)="showChildren(category, $event, items)"
        ></i>
      </div>
      <div
        class="children-menu-backdrop"
        [class.show]="category.selected || category.isShow"
        (click)="closeAllSubmenus(categories)"
      >
      <ul
        class="children-menu"
        *ngIf="category.children?.length"
        [ngStyle]="category.popupStyle"
      >
        <ng-container
          *ngTemplateOutlet="
            recursiveMenu;
            context: { $implicit: category.children }
          "
        ></ng-container>
      </ul>
      </div>
    </div>
  </ng-container>
</ng-template>
